import * as angular from "angular";
import {IController, IScope} from "angular";
import {TaskModel} from "../../models/task.model";

export class TaskSummeryLineCtrl implements IController {
  id: any;
  entity: any;
  small: any;
  showTimeWindow: any;
  public task: TaskModel;

  constructor(private $scope: IScope, private $task) {
  }

  $onInit() {
    if (this.id) {
      this.$task(this.id).$bindCtrl(this.$scope, this, 'task');
      // $route($scope.id).$bindCtrl(this.$scope, this, 'route');
    } else {
      if (this.entity) {
        this.task = this.entity;
      }
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.id || changes.entity) {
      this.$onInit();
    }
  }
}

angular
  .module('bringoz.admin.tasks')
  .component('taskSummeryLine', {
    bindings: {
      id: '<',
      entity: '<',
      small: '<',
      showTimeWindow: '<'
    },
    template: require('./task-summery-line.html').default,
    controller: TaskSummeryLineCtrl
  });
